import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import BankCreate from "../../components/Bank/BankCreate";

const BankCreatePage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <BankCreate/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};

export default BankCreatePage;